import React from 'react';
import styled from 'styled-components';
import {Card} from '../../elements/card/Card';
import {scrollWhite} from '../../../shared-components/custom-features/scroll/scroll';
import {SingleCheckBox} from '../../forms/form-control/checkbox-single/SingleCheckBox';
import {ColorTheme} from '../../../shared-components/variables/feature-colors/ColorTheme';

export const OptionCard = ({children, selectionBtn, footer}) => (
    <ColorTheme>
        <OptionList>
            <Wrapper>{selectionBtn}</Wrapper>
            <OptionContainer>{children}</OptionContainer>
            <BtnWrapper>{footer}</BtnWrapper>
        </OptionList>
    </ColorTheme>
);

export const OptionList = styled(Card)`
    min-width: 200px;

    ${Card.Body} {
        padding: 0;
    }

    ${SingleCheckBox.Wrapper} {
        display: flex;
        align-items: center;
    }
`;

const Wrapper = styled.div`
    padding: 8px 20px;
`;

const OptionContainer = styled(Wrapper)`
    border-top: 1px solid var(--container-border-color-100);
    max-height: 80vh;
    overflow-y: auto;
    ${scrollWhite()};
    background: var(--container-background-color-200);
    padding-bottom: 12px;
`;

const BtnWrapper = styled(Wrapper)`
    background: var(--container-background-color-200);
    position: relative;
    border-radius: 0 0 8px 8px;
    &::before {
        content: '';
        height: 20px;
        width: 100%;
        top: -20px;
        left: 0;
        position: absolute;
        pointer-events: none;
        background-image: linear-gradient(to top, var(--container-background-color-200), #fafafe00);
    }
`;
